module.exports = __webpack_public_path__ + "img/ticketbg.40664621.png";